import {
  OrderItem,
  PaginationData,
} from 'constants/interface';
import { OrderItemApiStatusEnum } from 'constants/order';
// import { InventoryTypeEnum } from 'constants/inventory';
// import {
//   OrderItemApiStatus,
// } from 'constants/order';
import {
  buildPaginationParams,
  getPaginationHeaders,
  PaginatedResponse,
  requestClient,
} from 'infra/request';

export interface GetOrderItemList extends PaginationData {
  status?: OrderItemApiStatusEnum
}

export interface OrderItemApi {
  getOrderItem(orderItemId: string): Promise<OrderItem>
  getOrderItemList(filter: GetOrderItemList): Promise<PaginatedResponse<OrderItem>>
}

const orderItemApiBuilder = (): OrderItemApi => {
  const getOrderItem = async (
    orderItemId: string,
  ): Promise<OrderItem> => {
    const result = await requestClient.get(`/order-items/${orderItemId}`);
    const orderItem: OrderItem = result.data as OrderItem;
    return orderItem;
  };

  const getOrderItemList = async (
    filterData: GetOrderItemList,
  ): Promise<PaginatedResponse<OrderItem>> => {
    const params = buildPaginationParams(filterData);
    const result = await requestClient.get('/order-items', params);
    const pagination = getPaginationHeaders(result);
    const orderItemList: OrderItem[] = result.data as OrderItem[];
    return {
      pagination,
      data: orderItemList,
    };
  };

  return {
    getOrderItem,
    getOrderItemList,
  };
};

export const orderItemApi = orderItemApiBuilder();
